const landingspageLogo = document.querySelector('[data-landingspage-logo]');
const landingsVideo = document.querySelector('[data-landing-video]');
const landingScrollDownIndicator = document.querySelector('[data-landing-scroll-down]');

export default function initLandingspage() {
    if (landingspageLogo) {
        window.addEventListener('scroll', () => {
            if (window.scrollY <= 500) {
                landingspageLogo.classList.remove('sticky-logo');
            } else {
                landingspageLogo.classList.add('sticky-logo');
            }
        });

        // Load mobile video instead of desktop
        if (window.innerWidth <= 768) {
            landingsVideo.setAttribute('src', landingsVideo.getAttribute('src').replace('776649414', '776649370'));
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth <= 768) {
                landingsVideo.setAttribute('src', landingsVideo.getAttribute('src').replace('776649414', '776649370'));
            } else {
                landingsVideo.setAttribute('src', landingsVideo.getAttribute('src').replace('776649370', '776649414'));
            }
        });

        // Show scroll indicator
        setTimeout(() => {
            landingScrollDownIndicator.classList.add('fadein');
        }, 5000);
    }
}
